import React from "react";

const DegreeCertReq = () => {
  return (
    <div className="birthCertPurposeContainer">
      <h2>
        The Degree Certificate <span>Attestation</span> Process
      </h2>
      <p>
        The degree certificate attestation process involves several steps to
        ensure that the document is genuine and recognized internationally:
      </p>
      <ul>
        <li>
          <span>•</span> Original degree certificate
        </li>
        <li>
          <span>•</span> Photocopies of the degree certificate
        </li>
        <li>
          <span>•</span> Passport copy of the certificate holder
        </li>
        <li>
          <span>•</span> Passport-sized photographs
        </li>
        <li>
          <span>•</span> Authorization letter (if someone else is submitting the
          documents on your behalf)
        </li>
      </ul>
    </div>
  );
};

export default DegreeCertReq;
